/* Thistle Hill | Always-on glitter for Gift Guides navigation and Gift Guide page heading.
   Same canvas engine, palette, and animation for both. */
(function () {
  'use strict';

  const SELECTOR =
    '.header__inline-menu summary.header__menu-item > span, ' +
    '.header__inline-menu > .list-menu > li > a.header__menu-item > span, ' +
    '[data-thistle-glitter-heading]';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const BLEED_X = 12;
  const BLEED_Y = 5;
  const FRAME_INTERVAL = 32; // approximately 30 frames per second
  const SILVERS = ['#fff9e9', '#f8e7b5', '#edce82', '#d5a74f', '#ac7d2e', '#78551e'];

  function decorate(label) {
    if (label.dataset.thistleGlitterInit === 'true') return;

    const rawText = label.textContent.trim().replace(/\s+/g, ' ');
    if (rawText.toLowerCase() !== 'gift guides' &&
        !label.hasAttribute('data-thistle-glitter-heading')) return;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const maskCanvas = document.createElement('canvas');
    const maskCtx = maskCanvas.getContext('2d');
    const grainCanvas = document.createElement('canvas');
    const grainCtx = grainCanvas.getContext('2d');
    if (!ctx || !maskCtx || !grainCtx) return;
    label.dataset.thistleGlitterInit = 'true';

    canvas.className = 'thistle-glitter-ink';
    canvas.setAttribute('aria-hidden', 'true');
    label.classList.add('thistle-gift-guide-label');
    label.appendChild(canvas);

    let width = 0;
    let height = 0;
    let sparkles = [];
    let raf = null;
    let lastFrame = -Infinity;
    let observer = null;
    let ready = false;

    function transformedText(style) {
      if (style.textTransform === 'uppercase') return rawText.toUpperCase();
      if (style.textTransform === 'lowercase') return rawText.toLowerCase();
      if (style.textTransform === 'capitalize') {
        return rawText.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      }
      return rawText;
    }

    function drawTextMask(style, text) {
      // Render text at its existing navigation size and font family.
      maskCtx.save();
      maskCtx.fillStyle = '#ffffff';
      maskCtx.strokeStyle = '#ffffff';
      maskCtx.lineWidth = 0.28; // subtle extra ink, not a heavy outline
      maskCtx.lineJoin = 'round';
      maskCtx.textBaseline = 'alphabetic';
      maskCtx.font = [
        style.fontStyle || 'normal',
        style.fontWeight || '500',
        style.fontSize,
        style.fontFamily
      ].join(' ');

      const measurements = maskCtx.measureText(text);
      const ascent = measurements.actualBoundingBoxAscent || parseFloat(style.fontSize) * 0.75;
      const descent = measurements.actualBoundingBoxDescent || parseFloat(style.fontSize) * 0.2;
      const baseline = (height + ascent - descent) / 2;
      const spacing = style.letterSpacing === 'normal' ? '0px' : style.letterSpacing;

      if ('letterSpacing' in maskCtx) {
        // Modern browsers can measure and paint the full word with kerning.
        maskCtx.letterSpacing = spacing;
        maskCtx.textAlign = 'center';
        maskCtx.fillText(text, width / 2, baseline);
        maskCtx.strokeText(text, width / 2, baseline);
      } else {
        // Fallback for older Safari: manually preserve navigation tracking.
        const chars = Array.from(text);
        const charWidths = chars.map(function (c) { return maskCtx.measureText(c).width; });
        const letterGap = parseFloat(spacing) || 0;
        const totalWidth = charWidths.reduce(function (sum, w) { return sum + w; }, 0) +
          letterGap * chars.length;
        let x = (width - totalWidth) / 2;
        maskCtx.textAlign = 'left';
        chars.forEach(function (char, i) {
          maskCtx.fillText(char, x, baseline);
          maskCtx.strokeText(char, x, baseline);
          x += charWidths[i] + letterGap;
        });
      }
      maskCtx.restore();
    }

    function rebuild() {
      const rect = label.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return false;

      width = rect.width + BLEED_X * 2;
      height = rect.height + BLEED_Y * 2;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const pixelWidth = Math.ceil(width * dpr);
      const pixelHeight = Math.ceil(height * dpr);

      canvas.style.left = -BLEED_X + 'px';
      canvas.style.top = -BLEED_Y + 'px';
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      canvas.width = pixelWidth;
      canvas.height = pixelHeight;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      maskCanvas.width = pixelWidth;
      maskCanvas.height = pixelHeight;
      maskCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
      maskCtx.clearRect(0, 0, width, height);
      const style = getComputedStyle(label);
      drawTextMask(style, transformedText(style));

      // Sample actual painted letter pixels so sparkles never get wasted
      // in the empty space around the letters.
      const rgba = maskCtx.getImageData(0, 0, pixelWidth, pixelHeight).data;
      const inkPoints = [];
      for (let py = 0; py < pixelHeight; py += 2) {
        for (let px = 0; px < pixelWidth; px += 2) {
          if (rgba[(py * pixelWidth + px) * 4 + 3] > 96) {
            inkPoints.push({ x: (px + 0.5) / dpr, y: (py + 0.5) / dpr });
          }
        }
      }
      if (!inkPoints.length) return false;

      function inkPoint() {
        return inkPoints[Math.floor(Math.random() * inkPoints.length)];
      }

      // Fixed glitter texture: many tiny irregular reflective particles.
      grainCanvas.width = pixelWidth;
      grainCanvas.height = pixelHeight;
      grainCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
      grainCtx.fillStyle = '#a67b36';
      grainCtx.fillRect(0, 0, width, height);

      const flakeCount = Math.max(700, Math.round(inkPoints.length * 2.5));
      for (let i = 0; i < flakeCount; i++) {
        const p = inkPoint();
        const size = 0.35 + Math.random() * 1.0;
        grainCtx.globalAlpha = 0.35 + Math.random() * 0.65;
        grainCtx.fillStyle = SILVERS[Math.floor(Math.random() * SILVERS.length)];
        grainCtx.fillRect(p.x - size / 2, p.y - size / 2, size, size);
      }
      grainCtx.globalAlpha = 1;

      // Independent flashes, at random locations in the letter shapes.
      const isHeading = label.hasAttribute('data-thistle-glitter-heading');
      const count = isHeading
        ? Math.max(110, Math.min(350, Math.round(inkPoints.length * 0.16)))
        : Math.max(32, Math.min(70, Math.round(rect.width * 0.33)));
      sparkles = Array.from({ length: count }, function () {
        const p = inkPoint();
        return {
          x: p.x,
          y: p.y,
          size: 0.65 + Math.random() * 1.1,
          phase: Math.random() * Math.PI * 2,
          speed: 2.5 + Math.random() * 6,
          burst: Math.random() < 0.38
        };
      });
      return true;
    }

    function paint(time) {
      ctx.clearRect(0, 0, width, height);
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.drawImage(grainCanvas, 0, 0, width, height);

      sparkles.forEach(function (s) {
        const bright = reducedMotion.matches
          ? 0.4
          : Math.pow(Math.max(0, Math.sin(time * 0.001 * s.speed + s.phase)), 6);
        if (bright < 0.03) return;

        ctx.globalAlpha = bright;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(s.x - s.size / 2, s.y - s.size / 2, s.size, s.size);
        if (s.burst && bright > 0.52) {
          const radius = 1 + bright * 1.65;
          ctx.strokeStyle = '#ffffff';
          ctx.lineWidth = 0.6;
          ctx.beginPath();
          ctx.moveTo(s.x - radius, s.y);
          ctx.lineTo(s.x + radius, s.y);
          ctx.moveTo(s.x, s.y - radius);
          ctx.lineTo(s.x, s.y + radius);
          ctx.stroke();
        }
      });

      // Final alpha mask: no silver or light can escape the text outlines.
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'destination-in';
      ctx.drawImage(maskCanvas, 0, 0, width, height);
      ctx.globalCompositeOperation = 'source-over';
    }

    function stop() {
      if (raf !== null) cancelAnimationFrame(raf);
      raf = null;
    }

    function frame(now) {
      if (!label.isConnected) {
        stop();
        if (observer) observer.disconnect();
        document.removeEventListener('visibilitychange', start);
        return;
      }
      if (now - lastFrame >= FRAME_INTERVAL) {
        paint(now);
        lastFrame = now;
      }
      raf = requestAnimationFrame(frame);
    }

    function start() {
      stop();
      if (!reducedMotion.matches && !document.hidden && ready) {
        lastFrame = -Infinity;
        raf = requestAnimationFrame(frame);
      }
    }

    function refresh() {
      stop();
      if (!rebuild()) return;
      ready = true;
      paint(performance.now());
      label.classList.add('thistle-glitter-ready');
      label.dataset.thistleGlitterReady = 'true';
      start();
    }

    refresh();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(refresh);
      observer.observe(label);
    } else {
      window.addEventListener('resize', refresh, { passive: true });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    document.addEventListener('visibilitychange', start);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', refresh);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(function (label) {
      // Only the top-level label, never an item inside the dropdown itself.
      if (label.closest('.header__submenu')) return;
      decorate(label);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();